import React from 'react';
import MainBody from '../../components/layout/MainBody';
import MainSection from './MainSection';


export default function Main() {
  return (
    <MainBody>
        <MainSection>
        </MainSection>
    </MainBody>
  );
};